var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error",
    clipPath: "url(#clip0_11950_62938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location_Mileage_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M127.39 127.574C156.592 98.5414 156.592 51.4703 127.39 22.4378C98.189 -6.59473 50.8444 -6.59473 21.6431 22.4378C-7.55816 51.4703 -7.55816 98.5414 21.6431 127.574C50.8444 156.606 98.189 156.606 127.39 127.574Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M135.024 8.95431C134.215 10.7729 135.024 12.9063 136.853 13.7107C138.682 14.515 140.793 13.7107 141.637 11.927C142.446 10.1084 141.672 7.97506 139.843 7.17068C138.014 6.33132 135.833 7.1357 135.024 8.95431Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M129.677 1.88724C129.149 3.04136 129.677 4.40531 130.838 4.92991C131.998 5.45451 133.37 4.92991 133.863 3.77579C134.39 2.62168 133.898 1.25772 132.737 0.733126C131.611 0.208528 130.204 0.733126 129.677 1.88724Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5238 138.599C10.7851 140.452 11.6997 142.551 13.5289 143.285C15.358 144.02 17.4686 143.145 18.2073 141.292C18.946 139.473 18.0666 137.34 16.2374 136.605C14.4083 135.871 12.2625 136.745 11.5238 138.599Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.89122 131.782C5.39875 132.936 5.99675 134.3 7.19275 134.755C8.35357 135.209 9.69028 134.65 10.1827 133.496C10.64 132.341 10.1124 130.977 8.9164 130.523C7.7204 130.033 6.34851 130.593 5.89122 131.782Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M137.595 133.32C136.293 134.824 136.504 137.098 138.017 138.392C139.53 139.686 141.816 139.511 143.118 138.007C144.419 136.503 144.243 134.23 142.766 132.936C141.218 131.642 138.896 131.852 137.595 133.32Z",
    fill: "#F0F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.543 30.5625H79.5925C83.9734 30.5625 87.5578 34.1469 87.5578 38.5278V99.7613C87.5578 104.142 83.9734 107.727 79.5925 107.727H33.543C29.162 107.727 25.5776 104.142 25.5776 99.7613V38.5278C25.5776 34.0971 29.162 30.5625 33.543 30.5625Z",
    fill: "url(#paint0_linear_11950_62938)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.4931 40.5195H53.506C54.8501 40.5195 55.9454 41.6148 55.9454 42.9589C55.9454 44.3031 54.8501 45.3983 53.506 45.3983H33.4931C32.1489 45.3983 31.0537 44.3031 31.0537 42.9589C31.0537 41.565 32.1489 40.5195 33.4931 40.5195Z",
    fill: "#F01A72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.4931 54.3574H78.3976C79.7418 54.3574 80.837 55.4527 80.837 56.7968C80.837 58.141 79.7418 59.2362 78.3976 59.2362H33.4931C32.1489 59.2362 31.0537 58.141 31.0537 56.7968C31.0537 55.4029 32.1489 54.3574 33.4931 54.3574Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.4931 68.1973H78.3976C79.7418 68.1973 80.837 69.2925 80.837 70.6367C80.837 71.9808 79.7418 73.076 78.3976 73.076H33.4931C32.1489 73.076 31.0537 71.9808 31.0537 70.6367C31.0537 69.2427 32.1489 68.1973 33.4931 68.1973Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.4931 82.0371H78.3976C79.7418 82.0371 80.837 83.1323 80.837 84.4765C80.837 85.8206 79.7418 86.9159 78.3976 86.9159H33.4931C32.1489 86.9159 31.0537 85.8206 31.0537 84.4765C31.0537 83.0826 32.1489 82.0371 33.4931 82.0371Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.4931 95.8789H78.3976C79.7418 95.8789 80.837 96.9741 80.837 98.3183C80.837 99.6624 79.7418 100.758 78.3976 100.758H33.4931C32.1489 100.758 31.0537 99.6624 31.0537 98.3183C31.0537 96.9244 32.1489 95.8789 33.4931 95.8789Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M94.7763 22.7467H124.696C125.681 22.7467 126.488 23.5598 126.488 24.6883V39.4242C126.488 40.4837 125.65 41.3159 124.696 41.3159H94.7763C93.8224 41.3159 92.9841 40.4837 92.9841 39.4242V24.6385C92.9841 23.579 93.8224 22.7467 94.7763 22.7467Z",
    fill: "#F2F8FF",
    stroke: "white",
    strokeWidth: 1.4935
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M99.7551 35.2435C101.398 35.2435 102.742 33.8994 102.742 32.2565C102.742 30.6137 101.398 29.2695 99.7551 29.2695C98.1122 29.2695 96.7681 30.6137 96.7681 32.2565C96.7681 33.8994 98.1122 35.2435 99.7551 35.2435Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M109.711 29.2695H119.668C121.311 29.2695 122.655 30.6137 122.655 32.2565C122.655 33.8994 121.311 35.2435 119.668 35.2435H109.711C108.069 35.2435 106.724 33.8994 106.724 32.2565C106.724 30.6137 108.069 29.2695 109.711 29.2695Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4195 111.21C79.8415 111.21 85.7657 109.268 90.7441 105.933L111.006 125.298L118.374 116.785L98.809 98.1166C102.443 93.0387 104.534 86.8158 104.534 80.095C104.534 62.9198 90.5947 48.9805 73.4195 48.9805C56.2443 48.9805 42.3049 62.9198 42.3049 80.095C42.3049 97.2703 56.2443 111.21 73.4195 111.21ZM99.954 80.095C99.954 94.6317 88.1553 106.43 73.6186 106.43C59.0819 106.43 47.2833 94.6317 47.2833 80.095C47.2833 65.5583 59.0819 53.7597 73.6186 53.7597C88.1553 53.7597 99.954 65.5085 99.954 80.095Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M78.2982 80.0474L84.8696 73.5258C85.467 72.8786 85.8155 72.0323 85.8155 71.1362C85.8155 70.2401 85.4172 69.3938 84.8198 68.7466C84.1726 68.0994 83.3263 67.7509 82.4302 67.7509C81.5341 67.7509 80.6878 68.0496 80.0406 68.6968L73.4692 75.2184L66.8978 68.6968C66.5991 68.3483 66.2009 68.0994 65.8026 67.9003C65.4043 67.7011 64.9065 67.6016 64.4585 67.6016C64.0104 67.6016 63.5624 67.7011 63.1143 67.8505C62.6663 67.9998 62.3178 68.2985 61.9693 68.5972C61.6208 68.8959 61.3719 69.2942 61.2225 69.7422C61.0732 70.1903 60.9736 70.6383 60.9736 71.0864C60.9736 71.5344 61.0732 71.9825 61.2723 72.4305C61.4715 72.8288 61.7204 73.2271 62.0689 73.5258L68.6403 80.0474L62.0689 86.569C61.7204 86.8677 61.4715 87.266 61.2723 87.6642C61.0732 88.0625 60.9736 88.5105 60.9736 89.0084C60.9736 89.4564 61.0732 89.9045 61.2225 90.3525C61.3719 90.8006 61.6706 91.1491 61.9693 91.4975C62.3178 91.7962 62.6663 92.0949 63.1143 92.2443C63.5624 92.3936 64.0104 92.4932 64.4585 92.4932C64.9065 92.4932 65.3546 92.3936 65.8026 92.1945C66.2009 91.9954 66.5991 91.7465 66.8978 91.398L73.4692 84.8764L80.0406 91.398C80.6878 91.9954 81.5341 92.2941 82.4302 92.2443C83.3263 92.1945 84.1229 91.846 84.77 91.2486C85.3674 90.6512 85.7657 89.8049 85.7657 88.9586C85.8155 88.1123 85.467 87.266 84.9194 86.569L78.2982 80.0474Z",
    fill: "url(#paint1_linear_11950_62938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M111.006 125.251L118.374 116.738L119.469 117.784C120.564 118.829 121.161 120.223 121.261 121.766C121.311 123.31 120.813 124.803 119.867 125.898C118.871 127.043 117.527 127.691 116.084 127.79C114.64 127.84 113.196 127.342 112.151 126.297L111.006 125.251Z",
    fill: "#C6D4E7"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11950_62938",
    x1: 56.5769,
    y1: 30.5406,
    x2: 56.5769,
    y2: 107.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11950_62938",
    x1: 67.3221,
    y1: 86.2703,
    x2: 80.3683,
    y2: 70.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11950_62938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4f4a2707c2cc28d023510db2a9d3f48e.svg";
export { ForwardRef as ReactComponent };